import Stack from "@mui/material/Stack";
import RenderTextField from "../../../Utilities/Forms/RenderTextField";
import DataContainer from "../../../Utilities/DataContainer";
import { useFormContext } from "react-hook-form-mui";
import NumberInputField from "../../../Utilities/Forms/NumberInputField";

interface IProps {
    isReadOnly: boolean;
    landuse: string;
    subuse: string;
}

export default function ResidentialUnits({ isReadOnly, landuse, subuse }: IProps) {
    const { watch } = useFormContext();

    var unitDensity = watch("unitDensity");
    const averageBedroomsPerOccupiedDewlling = watch("residentialUnits.averageBedroomsPerOccupiedDewlling");
    return (
        <DataContainer title="Residential Details">
            <Stack spacing={1}>
                {
                    (
                        (landuse === "03" && !"EHJQ".includes(subuse)) ||
                        landuse === "17"
                    ) && (
                        <>
                            {(averageBedroomsPerOccupiedDewlling != null || !isReadOnly) && (
                                <NumberInputField
                                    label="Average bedrooms per unit"
                                    name="residentialUnits.averageBedroomsPerOccupiedDewlling"
                                    readOnly={isReadOnly}
                                />
                            )}

                            <RenderTextField
                                label="No of units with 1 bedroom"
                                name="residentialUnits.totalOccupiedDwellingWith1Bedroom"
                                readOnly={isReadOnly}
                            />
                            <RenderTextField
                                label="No of units with 2 bedrooms"
                                name="residentialUnits.totalOccupiedDwellingWith2Bedroom"
                                readOnly={isReadOnly}
                            />
                            <RenderTextField
                                label="No of units with 3 bedrooms"
                                name="residentialUnits.totalOccupiedDwellingWith3Bedroom"
                                readOnly={isReadOnly}
                            />
                            <RenderTextField
                                label="No of units with 4+ bedrooms"
                                name="residentialUnits.totalOccupiedDwellingWith4PlusBedroom"
                                readOnly={isReadOnly}
                            />
                            <RenderTextField
                                label="Total bedrooms"
                                name="totalNumberOfBedrooms"
                                readOnly={isReadOnly}
                            />
                            {(unitDensity != null || !isReadOnly) && (
                                <NumberInputField
                                    label="Unit density"
                                    name="unitDensity"
                                    readOnly={isReadOnly}
                                />
                            )}
                        </>
                    )
                }
            </Stack>
        </DataContainer >
    );
}
